import { api } from '../../../../app/auth/apiSlice';

export interface Guidedtour {
  guided_tour?: string;
  loading_page?: string;
  welcome_modal?: string;
  popup_modal?: boolean;
  popup_settings?: number | null;
}

const ApplicationSettingApi = api
  .enhanceEndpoints({ addTagTypes: ['GuidedTour'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      updateApplicationSetting: builder.mutation<void, Guidedtour>({
        query: (tour) => ({
          url: `v1/main/user-settings/`,
          method: 'PUT',
          body: tour,
        }),
      }),
    }),
  });

export const { useUpdateApplicationSettingMutation } = ApplicationSettingApi;
